import type { PageModule } from "./types";

export const getModuleType = (module: PageModule): string =>
    "type" in module ? module.type : module.sys.contentType.sys.id;

export const getModuleId = (module: PageModule): string =>
    "model" in module ? module.id : module.sys.id;

// Editors can link the same entry twice or more in a list, so repeats get a counter to keep keys unique.
export const withModuleKeys = (modules: PageModule[]): { key: string; module: PageModule }[] => {
    const occurrences = new Map<string, number>();

    return modules.map((module) => {
        const id = getModuleId(module);
        const occurrence = occurrences.get(id) ?? 0;
        occurrences.set(id, occurrence + 1);

        return { key: occurrence ? `${id}-${occurrence}` : id, module };
    });
};
